module.exports = __webpack_public_path__ + "img/overview_minus.21de179b.svg";